import { gql } from "@apollo/client";

export const updateUserOnboardingFormResponse = gql`
  mutation UpdateUserOnboardingFormResponse(
    $formResponses: JSON
    $reviewed: Boolean
  ) {
    updateUserOnboardingFormResponse(
      formResponses: $formResponses
      reviewed: $reviewed
    ) {
      id
      organizationId
      formResponses
      reviewed
    }
  }
`;

export const addUserOnboardingFormResponse = gql`
  mutation CreateOnboardingData($data: JSON) {
    createOnboardingData(data: $data) {
      data {
        id
        organizationId
        label
        path
        subSteps
      }
    }
  }
`;
